module.exports = __webpack_public_path__ + "img/IT0004009719250.338293e8.png";